import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()((theme) => ({
  horizontal: {
    '&::-webkit-scrollbar': {
      height: theme.spacing(1),
      display: 'block',
    },

    '&::-webkit-scrollbar-track': {
      backgroundColor: `${theme.palette.modal.paper} !important`,
    },

    '&::-webkit-scrollbar-thumb': {
      backgroundColor: `${theme.palette.grey[800]} !important`,
    },
  },

  vertical: {
    '&::-webkit-scrollbar': {
      width: theme.spacing(1),
      display: 'block !important',
    },

    '&::-webkit-scrollbar-track': {
      backgroundColor: `${theme.palette.background.default} !important`,
    },

    '&::-webkit-scrollbar-thumb': {
      backgroundColor: `${theme.palette.grey[800]} !important`,
    },
  },
}));
